import Cookies from 'universal-cookie';
import { IMPERSONATE } from './constants';
import { updateCurrentCompanyIdCookie, updateCurrentIdentifierCookie } from './identifier';
import { removeCookies } from './cookies';
import Impersonate from 'models/Profile/Impersonate';

export const isImpersonate = () : boolean => {
  return getImpersonateData() !== undefined;
};

export const logoutImpersonate = (ignoreRedirect = false) : void => {
  const impersonate = getImpersonateData();

  updateCurrentIdentifierCookie(impersonate.true_user_company_identifier);
  updateCurrentCompanyIdCookie(impersonate.true_user_company);

  removeCookies(IMPERSONATE);

  if(!ignoreRedirect)
    location.href = `${process.env.REACT_APP_BIOID_BASE_URL}/users/${impersonate.true_user}/stop_impersonating`;
};

export const getRoute = () : string => {
  const impersonate = getImpersonateData();
  if(!impersonate)
    return '/api/v1';

  return '/api/v1/impersonate';
};

export const getImpersonateData = () : Impersonate => {
  return new Cookies().get(IMPERSONATE);
};